import type { User } from '@contactcentre-web/hooks/api/useOrderHistory';

export const userDisplayName = (user: User) => user?.name || user?.type;
